import React, { useLayoutEffect, SetStateAction, Dispatch, FC } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { IconLayoutGrid } from "@tabler/icons-react";
import { ViewName } from "../../../../components/Cards/templateCard/types";
import Button from "../../../../../../components/form/Button";
import { useParams, useNavigate, useLocation, useSearchParams } from "react-router-dom";

const options = [
    { value: 'Tower', label: "Torre" },
    { value: 'List', label: "Lista" },
    { value: 'Grid', label: "Cuadrícula" },
];

interface MenuViewProps {
    viewName: ViewName;
    setViewName: Dispatch<SetStateAction<ViewName>>;
    isDepto: boolean;
}

const MenuView: FC<MenuViewProps> = ({ viewName, setViewName, isDepto }) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { id = "" } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    useLayoutEffect(() => {
        const viewParam = searchParams.get('view');
        if (viewParam) {
            if (viewParam === 'Tower' && isDepto) {
                setViewName('Tower');
            } else {
                setViewName(viewParam as ViewName);
            }
        } else {
            if (isDepto) {
                setViewName('Tower');
            } else {
                setViewName('List');
            }
        }
    }, [isDepto, id, searchParams]);

    // @ts-ignore
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const onChangeView = (option: ViewName) => {
        setViewName(option);
        // Set view as query param in URL
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('view', option);
        navigate({ search: searchParams.toString() }, { replace: true });
        handleClose();
    }

    const filteredOptions = isDepto
        ? options
        : options.filter(opt => opt.value !== 'Tower'); // Filtrar la opción "Tower" si no es departamento


    return (
        <div>
            <Button
                onClick={handleClick}
                title={viewName === "Grid" ? 'Ver como lista' : 'Ver como cuadrícula'}
                variant="outlined"
            >
                <IconLayoutGrid className="size-6" />
            </Button>
            <Menu
                id="long-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {filteredOptions?.map((option) => (
                    <MenuItem
                        key={option.value}
                        selected={option.value === viewName}
                        onClick={() => onChangeView(option.value as ViewName)}
                    >
                        <span className='text-base text-black font-lati px-4'>
                            {option.label}
                        </span>
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
}

export default MenuView;